function hotels(state = [], action) {
    switch (action.type) {
        case 'HOTELS/SEASON/SET':
            return action.hotels;
        case 'HOTELS/SEASON/CLEAR':
            return null;
        default:
            return state;
    }
}

export default hotels;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/seasonHotels.js